import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ConfigDsdAdresseService {
  private readonly translateService = inject(TranslateService);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getConfigAdresseMouvement(): any {
    const pcKey = environment.keyPosteCanada;
    return {
      search: {
        projectId: pcKey,
      },
      street: {
        props: {
          required: true,
          maxlength: 30,
        },
        slots: {
          error: {
            required: this.getTraduction(
              'formulairePosteCanada.coordonneesMouvement.numeroEtRue.erreur.required',
            ),
            textevide: this.getTraduction(
              'formulairePosteCanada.coordonneesMouvement.numeroEtRue.erreur.textevide',
            ),
            separation: this.getTraduction(
              'formulairePosteCanada.coordonneesMouvement.numeroEtRue.erreur.separation',
            ),
            authorizedCharacters: this.getTraduction(
              'formulairePosteCanada.coordonneesMouvement.numeroEtRue.erreur.authorizedCharacters',
            ),
            maxlength: this.getTraduction(
              'formulairePosteCanada.coordonneesMouvement.numeroEtRue.erreur.maxLength',
            ),
          },
        },
      },
      unit: {
        props: {
          required: false,
          maxlength: 6,
        },
        slots: {
          error: {
            maxlength: this.getTraduction(
              'formulairePosteCanada.coordonneesMouvement.appartement.erreur.maxLength',
            ),
            appartement: this.getTraduction(
              'formulairePosteCanada.coordonneesMouvement.appartement.erreur.appartement',
            ),
          },
        },
      },
      city: {
        props: {
          required: true,
          maxlength: 30,
        },
        slots: {
          error: {
            required: this.getTraduction(
              'formulairePosteCanada.coordonneesMouvement.ville.erreur.required',
            ),
            textevide: this.getTraduction(
              'formulairePosteCanada.coordonneesMouvement.ville.erreur.textevide',
            ),
            maxlength: this.getTraduction(
              'formulairePosteCanada.coordonneesMouvement.ville.erreur.maxLength',
            ),
            authorizedCharacters: this.getTraduction(
              'formulairePosteCanada.coordonneesMouvement.ville.erreur.authorizedCharacters',
            ),
          },
        },
      },
      pc: {
        props: {
          required: true,
        },
        slots: {
          error: {
            required: this.getTraduction(
              'formulairePosteCanada.coordonneesMouvement.codePostal.erreur.required',
            ),
          },
        },
      },
    };
  }

  private getTraduction(cleTraduction: string): string {
    let texteTraduction = '';
    this.translateService
      .get(cleTraduction)
      .subscribe((texte: string) => (texteTraduction = texte));
    return texteTraduction;
  }
}
